/* Turns a tool name into a status phrase, e.g. "list_profiles" -> "Reading profiles".
   Tool names may carry a service prefix ("drift-get_ssp_drift"), which is dropped so the
   verb still maps. Unknown shapes fall back to the humanized name. */
export const TOOL_VERBS: Record<string, string> = {
  list: "Reading",
  get: "Reading",
  fetch: "Reading",
  read: "Reading",
  load: "Reading",
  search: "Searching",
  find: "Searching",
  query: "Searching",
  count: "Counting",
  summarize: "Summarizing",
  analyze: "Analyzing",
};

const humanize = (name: string) => name.replace(/[_-]+/g, " ").trim().toLowerCase();

export function toolLabel(tool?: string): string {
  if (!tool?.trim()) return "Thinking";
  // "drift-get_ssp_drift" -> "get_ssp_drift": the leading segment names the service, not the action.
  // Only stripped when what remains still starts with a verb, so a kebab-case name like
  // "get-ssp-drift" keeps its verb instead of losing it to the prefix rule.
  const dash = tool.indexOf("-");
  const stripped = dash >= 0 ? humanize(tool.slice(dash + 1)) : "";
  const raw = TOOL_VERBS[stripped.split(" ")[0]] ? stripped : humanize(tool);
  // A name that was only a prefix ("drift-", "-") humanizes to nothing.
  if (!raw) return "Thinking";
  const [verb, ...rest] = raw.split(" ");
  const mapped = TOOL_VERBS[verb];
  if (!mapped || rest.length === 0) return `Using ${raw}`;
  return `${mapped} ${rest.join(" ")}`;
}
